// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// function UpdateProfile() {
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [message, setMessage] = useState('');
//   const authData = localStorage.getItem("auth");

//   const navigate = useNavigate();
//   const authObject = JSON.parse(authData);
//   console.log("authObject", authObject);

//   const token = authObject?.accessToken;
//   console.log("token", token);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/user/getCurrentUser`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         console.log("res", res);
//         setFirstName(res.data.data.firstName);
//         setLastName(res.data.data.lastName);
//         setPhoneNumber(res.data.data.phoneNumber);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(`${API_BASE}/user/updateUserDetails`, {
//         firstName,
//         lastName,
//         phoneNumber,
//       }, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response.status === 200) {
//         setMessage("Profile updated successfully!");
//         const updatedAuthData = {
//           ...authObject,
//           user: { ...authObject.user, firstName, lastName, phoneNumber },
//         };
//         localStorage.setItem("auth", JSON.stringify(updatedAuthData));

//         navigate("/profile");
//       }
//     } catch (error) {
//       setMessage("Failed to update profile. Please try again.");
//     }
//   };
// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//    <div
//   className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
//   style={{
//     backgroundImage:
//       "url('https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
//   }}
// >
//   <div className="max-w-md w-full my-10 p-5 border border-gray-300 rounded-md shadow-md bg-white bg-opacity-95">
//     <h2 className="text-center text-2xl mb-6 text-gray-800">Update Profile</h2>
//     <form onSubmit={handleSubmit}>
//       <div className="mb-4">
//         <label className="block text-gray-700">First Name</label>
//         <input
//           type="text"
//           className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//           placeholder="Enter your first name"
//           value={firstName}
//           onChange={(e) => setFirstName(e.target.value)}
//         />
//       </div>
//       <div className="mb-4">
//         <label className="block text-gray-700">Last Name</label>
//         <input
//           type="text"
//           className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//           placeholder="Enter your last name"
//           value={lastName}
//           onChange={(e) => setLastName(e.target.value)}
//         />
//       </div>
//       <div className="mb-4">
//         <label className="block text-gray-700">Phone Number</label>
//         <input
//           type="text"
//           className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//           placeholder="Enter your phone number"
//           value={phoneNumber}
//           onChange={(e) => setPhoneNumber(e.target.value)}
//         />
//       </div>
//       <button
//         type="submit"
//         className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//       >
//         Save Changes
//       </button>
//       {message && <p className="mt-4 text-center text-gray-700">{message}</p>}
//     </form>
//   </div>
// </div>

//   );
// }

// export default UpdateProfile;
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd'; // Use Antd message for notifications

// Global constant
const API_BASE = process.env.REACT_APP_API_BASE;

// ------------------- FULL SCREEN LOADER COMPONENT -------------------

const FullScreenLoader = () => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-green-700 bg-opacity-90">
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mb-4"></div>
        <p className="text-white text-xl font-semibold">Loading Data...</p>
      </div>
    </div>
);

function UpdateProfile() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loadingInitial, setLoadingInitial] = useState(true); // For initial data fetch
  const [loadingSubmit, setLoadingSubmit] = useState(false); // For form submission

  const navigate = useNavigate();
  
  // --- Auth Data Retrieval ---
  let authObject = null;
  try {
    const authData = localStorage.getItem("auth");
    if (authData) {
      authObject = JSON.parse(authData);
    }
  } catch (error) {
    console.error("Error parsing auth data from localStorage:", error);
  }
  const token = authObject?.accessToken;

  // --- Initial Data Fetch ---
  useEffect(() => {
    // Check for token and redirect if missing
    if (!token) {
        setLoadingInitial(false);
        // message.error("Authentication required."); // Not required in this view
        return; 
    }

    const fetchData = async () => {
      setLoadingInitial(true);
      try {
        const res = await axios.get(`${API_BASE}/user/getCurrentUser`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setFirstName(res.data.data.firstName);
        setLastName(res.data.data.lastName);
        setPhoneNumber(res.data.data.phoneNumber);
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("Failed to load current profile data.");
      } finally {
        setLoadingInitial(false);
      }
    };
    fetchData();
  }, [token]);

  // --- Form Submission ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingSubmit(true);

    try {
      const response = await axios.post(`${API_BASE}/user/updateUserDetails`, {
        firstName,
        lastName,
        phoneNumber,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      if (response.status === 200) {
        message.success("Profile updated successfully!");
        
        // Update local storage to reflect changes immediately
        const updatedAuthData = {
          ...authObject,
          user: { ...authObject.user, firstName, lastName, phoneNumber },
        };
        localStorage.setItem("auth", JSON.stringify(updatedAuthData));

        // Navigate back to profile
        navigate("/profile");
      } else {
        message.error(response.data.message || "Failed to update profile. Please try again.");
      }
    } catch (error) {
      console.error("Update error:", error);
      message.error("Failed to update profile. Invalid input or server error.");
    } finally {
      setLoadingSubmit(false);
    }
  };

  if (loadingInitial) {
    return <FullScreenLoader />;
  }

  const isFormDisabled = loadingSubmit || !token;

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
      style={{
        backgroundImage:
          // Using a MF Blind-style suitable background
          "url('https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
      }}
    >
      <div className="max-w-md w-full my-10 p-8 border border-gray-200 rounded-lg shadow-2xl bg-white bg-opacity-95">
        
        {/* MF Blind-style Header */}
        <div className="mb-6 border-b pb-4 text-center">
            <h1 className="text-xl font-bold text-green-700">MF Blind</h1>
            <h2 className="text-2xl mt-2 text-gray-800">Update Profile Details</h2>
        </div>

        {/* Auth check warning */}
        {!token && (
            <p className="text-center text-red-500 mb-4">You must be logged in to update your profile.</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          
          {/* First Name */}
          <InputField
            label="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Enter your first name"
            disabled={isFormDisabled}
          />
          
          {/* Last Name */}
          <InputField
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Enter your last name"
            disabled={isFormDisabled}
          />

          {/* Phone Number */}
          <InputField
            label="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Enter your phone number"
            disabled={isFormDisabled}
            type="tel"
          />

          {/* Submit Button (MF Blind Green Style) */}
          <button
            type="submit"
            className="w-full py-3 mt-6 bg-green-700 text-white rounded-md font-semibold hover:bg-green-800 transition duration-150 shadow-md disabled:opacity-50"
            disabled={isFormDisabled}
          >
            {loadingSubmit ? 'Saving Changes...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default UpdateProfile;

// ------------------- Reusable Input Field (Copied from Login/Register) -------------------

const InputField = ({ label, name, type = "text", value, onChange, disabled, placeholder }) => (
  <div>
    <label className="block text-gray-700 text-sm mb-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100"
      placeholder={placeholder}
      required
    />
  </div>
);